import cn from 'classnames'
import React, { ComponentProps } from 'react'

export type ReportCycleUpsellSvgProps = {
  className?: string
} & ComponentProps<'svg'>
export default function ReportCycleUpsellSvg(props: ReportCycleUpsellSvgProps) {
  const { className = '', ...rest } = props
  return (
    <svg
      className={cn('ReportCycleUpsellSvg', className)}
      width="196"
      height="173"
      viewBox="0 0 196 173"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g filter="url(#filter0_d_18702_103988)">
        <rect
          x="5.46484"
          y="21.2999"
          width="160.104"
          height="127.723"
          rx="9.02035"
          fill="#1E3150"
        />
        <rect
          x="22.041"
          y="56.3671"
          width="36.9521"
          height="36.9524"
          rx="5.41221"
          fill="#BFDEF3"
        />
        <rect
          x="22.041"
          y="99.5653"
          width="36.9521"
          height="36.9524"
          rx="5.41221"
          fill="#BFDEF3"
        />
        <rect
          x="67.0186"
          y="56.3671"
          width="36.9521"
          height="36.9524"
          rx="5.41221"
          fill="#BFDEF3"
        />
        <rect
          x="67.0186"
          y="99.6"
          width="36.9521"
          height="36.9524"
          rx="5.41221"
          fill="#BFDEF3"
        />
        <rect
          x="111.965"
          y="99.6"
          width="36.9521"
          height="36.9524"
          rx="5.41221"
          fill="#BFDEF3"
        />
        <rect
          x="111.994"
          y="56.3671"
          width="36.9521"
          height="36.9524"
          rx="5.41221"
          fill="#BFDEF3"
        />
        <rect
          x="22.0391"
          y="40.3552"
          width="36.9525"
          height="7.04718"
          rx="3.52359"
          fill="white"
        />
        <rect
          x="67.0166"
          y="40.3552"
          width="36.9525"
          height="7.04718"
          rx="3.52359"
          fill="white"
        />
        <rect
          x="111.994"
          y="40.3552"
          width="36.9525"
          height="7.04718"
          rx="3.52359"
          fill="white"
        />
        <rect
          x="32.8117"
          y="5.54988"
          width="15.41"
          height="23.8033"
          rx="7.70501"
          fill="#BFDEF3"
          stroke="white"
          strokeWidth="0.9"
        />
        <rect
          x="78.1125"
          y="5.54988"
          width="15.41"
          height="23.8033"
          rx="7.70501"
          fill="#BFDEF3"
          stroke="white"
          strokeWidth="0.9"
        />
        <rect
          x="122.766"
          y="5.54988"
          width="15.41"
          height="23.8033"
          rx="7.70501"
          fill="#BFDEF3"
          stroke="white"
          strokeWidth="0.9"
        />
      </g>
      <g filter="url(#filter1_d_18702_103988)">
        <circle
          cx="151.896"
          cy="129.034"
          r="32.64"
          fill="url(#paint0_linear_18702_103988)"
        />
      </g>
      <path
        d="M140.021 115.27C146.591 109.184 156.423 109.091 163.083 114.647L157.804 114.852C157.122 114.88 156.595 115.457 156.623 116.155C156.65 116.834 157.195 117.364 157.849 117.364C157.868 117.364 157.877 117.364 157.895 117.364L166 117.057C166.664 117.029 167.182 116.48 167.182 115.801V115.708C167.182 115.689 167.182 115.68 167.182 115.661V115.652L166.882 107.444C166.854 106.746 166.282 106.206 165.61 106.234C164.928 106.262 164.401 106.839 164.428 107.537L164.619 112.683C161.321 109.919 157.259 108.319 152.915 108.095C147.536 107.816 142.365 109.705 138.376 113.409C132.888 118.5 130.562 126.242 132.306 133.613C132.443 134.19 132.942 134.571 133.497 134.571C133.597 134.571 133.688 134.562 133.788 134.534C134.442 134.367 134.851 133.687 134.687 133.017C133.161 126.54 135.196 119.737 140.021 115.27Z"
        fill="white"
        stroke="white"
        strokeWidth="1.2"
        strokeLinejoin="round"
      />
      <path
        d="M171.853 124.432C171.69 123.762 171.026 123.343 170.372 123.511C169.718 123.678 169.309 124.358 169.472 125.028C171.008 131.505 168.964 138.307 164.139 142.774C160.749 145.911 156.497 147.455 152.262 147.455C148.218 147.455 144.184 146.05 140.931 143.277L146.274 142.784C146.946 142.719 147.446 142.114 147.382 141.416C147.319 140.718 146.728 140.215 146.047 140.28L137.969 141.025C137.296 141.09 136.796 141.695 136.86 142.393L137.587 150.666C137.641 151.317 138.178 151.811 138.805 151.811C138.841 151.811 138.877 151.811 138.914 151.801C139.586 151.736 140.086 151.131 140.022 150.433L139.586 145.399C142.884 148.135 146.928 149.726 151.244 149.949C151.59 149.968 151.935 149.977 152.271 149.977C157.278 149.977 162.039 148.097 165.783 144.636C171.272 139.545 173.598 131.812 171.853 124.432Z"
        fill="white"
        stroke="white"
        strokeWidth="1.2"
        strokeLinejoin="round"
      />
      <defs>
        <filter
          id="filter0_d_18702_103988"
          x="0.764844"
          y="0.399854"
          width="175.504"
          height="159.323"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="3" dy="3" />
          <feGaussianBlur stdDeviation="3.85" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_18702_103988"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_18702_103988"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_18702_103988"
          x="114.556"
          y="91.6938"
          width="80.6793"
          height="80.68"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="3" dy="3" />
          <feGaussianBlur stdDeviation="3.85" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_18702_103988"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_18702_103988"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_18702_103988"
          x1="154.492"
          y1="82.9415"
          x2="105.814"
          y2="126.427"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00D0B4" />
          <stop offset="0.21" stopColor="#08C8BC" />
          <stop offset="0.54" stopColor="#1DB2D1" />
          <stop offset="0.95" stopColor="#3F8EF4" />
          <stop offset="1" stopColor="#4489F9" />
        </linearGradient>
      </defs>
    </svg>
  )
}
